import React, { Component } from 'react';
import { InputGroup, Button, ButtonToolbar, FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import ToggleButtonGroup from 'react-bootstrap/lib/ToggleButtonGroup'
import ToggleButton from 'react-bootstrap/lib/ToggleButton'
import ColorPicker from '../ColorPicker/ColorPicker'
import './ColorIO.css';

class ColorIO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputFormat: 'color_picker',
      inputBackground: '',
      rgbaValue: ''
    };
    this.handleInputFormatChange = this.handleInputFormatChange.bind(this);
    this.handleOutputFormatChange = this.handleOutputFormatChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handlePickColor = this.handlePickColor.bind(this);
    this.handleCopyToClipboard = this.handleCopyToClipboard.bind(this);
  }

  handleInputFormatChange(event) {
    this.setState({inputFormat: event});
    this.setState({outputValue: this.getOutputValue(this.state.inputValue, event, this.state.outputFormat)})
  }

  handleInputChange(event) {
    this.setState({inputValue: event.target.value});
    this.setState({outputValue: this.getOutputValue(event.target.value, this.state.inputFormat, this.state.outputFormat)})
  }

  handleOutputFormatChange(event) {
    this.setState({outputFormat: event});
    this.setState({outputValue: this.getOutputValue(this.state.inputValue, this.state.inputFormat, event)})
  }

  getOutputValue(inputValue, inputFormat, outputFormat) {
    return parseInt(inputValue, inputFormat).toString(outputFormat);
  }

  handlePickColor(rgba) {
    let hex = this.rgbaToHex(rgba);
    let hsla = this.rgbaToHsla(rgba);
    let cmyk = this.rgbaToCmyk(rgba);
    this.setState({...this.state, inputBackground: hex, hexValue: hex, rgbaValue: rgba, hslaValue: hsla, cmykValue: cmyk});
  }

  rgbaToCmyk(rgba) {
    let output = '';
    try {
      let regex = /^rgba\((\d{1,3}),\s?(\d{1,3}),\s?(\d{1,3})/
      let rgb = rgba.match(regex);
      let r_p = parseInt(rgb[1],10)/255;
      let g_p = parseInt(rgb[2],10)/255;
      let b_p = parseInt(rgb[3],10)/255;
      let k = 1-Math.max(r_p, g_p, b_p);
      let c = ((1-r_p)/(1-k))*100
      let m = ((1-g_p)/(1-k))*100
      let y = ((1-b_p)/(1-k))*100
      output = 'cmyk('+c+'%, '+m+'%, '+y+'%, '+k+'%)';
    } catch (e) {
      output = '';
    }
    return output;
  }

  rgbaToHsla(rgba) {
    let output = '';
    try {
      let regex = /^rgba\((\d{1,3}),\s?(\d{1,3}),\s?(\d{1,3})/
      let rgb = rgba.match(regex);
      let r_p = parseInt(rgb[1],10)/255;
      let g_p = parseInt(rgb[2],10)/255;
      let b_p = parseInt(rgb[3],10)/255;
      let cMin = Math.min(r_p, g_p, b_p);
      let cMax = Math.max(r_p, g_p, b_p);
      let delta = cMax - cMin;
      let h, s, l = (cMax + cMin) / 2;
      if(cMax === cMin) {
        h = s = 0; // achromatic
      } else {
        s = l > 0.5 ? delta / (2 - cMax - cMin) : delta / (cMax + cMin);
        switch(cMax) {
          case r_p:
            h = (g_p-b_p) / delta + (g_p < b_p ? 6 : 0);
            break;
          case g_p:
            h = (b_p-r_p) / delta + 2;
            break;
          case b_p:
            h = (r_p-g_p) / delta + 4;
            break;
        }
        h /= 6;
      }
      h = 360 * h;
      s = 100 * s;
      l = 100 * l;
      let a = rgba.substring(rgba.lastIndexOf(',')+1, rgba.lastIndexOf(')'))
      output = 'hsla('+h+', '+s+'%, '+l+'%,'+a+')';
    } catch (e) {

    }
    return output;
  }

  rgbaToHex(rgba) {
    let output = '';
    try {
      let regex = /^rgba\((\d{1,3}),\s?(\d{1,3}),\s?(\d{1,3})/
      let rgb = rgba.match(regex);
      output = "#" + ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
      ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
      ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2);
    } catch (e) {
      output = '';
    }
    return output;
  }

  handleCopyToClipboard(event) {
    let inp = document.querySelector('#'+event.target.value+'Display');
    if (inp && inp.select) {
      inp.select();
      document.execCommand('copy');
      inp.blur();
    } else {
      // console.log();
    }
  }

  render() {
    return (
      <div>
        {this.props.children}
        <div>
          {this.props.children}
          <FormGroup controlId="formControlsTextarea" className="top-buffer">
            <ControlLabel>Input</ControlLabel>
            <ButtonToolbar>
              <ToggleButtonGroup onChange={this.handleInputFormatChange} name="input_format" type="radio" defaultValue={this.state.inputFormat} >
                <ToggleButton value={'color_picker'}>Color</ToggleButton>
                {/* <ToggleButton value={'hex'}>Hex</ToggleButton>
                <ToggleButton value={'rgb'}>Rgb</ToggleButton>
                <ToggleButton value={'hsl'}>Hsl</ToggleButton>
                <ToggleButton value={'cmyk'}>Cmyk</ToggleButton> */}
              </ToggleButtonGroup>
            </ButtonToolbar>
            {/* <FormControl className="top-buffer" style={{backgroundColor: this.state.inputBackground}} value={this.state.inputValue} onChange={this.handleInputChange} componentClass="textarea" placeholder="Number Input" /> */}
          </FormGroup>

          <div className="top-buffer">
            <ColorPicker hidePreview={true} onPickColor={this.handlePickColor} />
          </div>


          <FormGroup className="top-buffer">
            <ControlLabel>Output</ControlLabel>
            <InputGroup>
              <InputGroup.Button>
                <Button className="fixed_width_button">Hex</Button>
              </InputGroup.Button>
              <FormControl value={this.state.hexValue} type="text" id="hexDisplay" style={{backgroundColor: this.state.inputBackground}} />
              <InputGroup.Button>
                <Button value="hex" onClick={this.handleCopyToClipboard}>Copy to Clipboard</Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>

          <FormGroup>
            <InputGroup>
              <InputGroup.Button>
                <Button className="fixed_width_button">Rgba</Button>
              </InputGroup.Button>
              <FormControl value={this.state.rgbaValue} type="text" id="rgbaDisplay" style={{backgroundColor: this.state.inputBackground}} />
              <InputGroup.Button>
                <Button value="rgba" onClick={this.handleCopyToClipboard}>Copy to Clipboard</Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>

          <FormGroup>
            <InputGroup>
              <InputGroup.Button>
                <Button className="fixed_width_button">Hsla</Button>
              </InputGroup.Button>
              <FormControl value={this.state.hslaValue} type="text" id="hslaDisplay" style={{backgroundColor: this.state.inputBackground}} />
              <InputGroup.Button>
                <Button value="hsla" onClick={this.handleCopyToClipboard}>Copy to Clipboard</Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>

          <FormGroup>
            <InputGroup>
              <InputGroup.Button>
                <Button className="fixed_width_button">Cmyk</Button>
              </InputGroup.Button>
              <FormControl value={this.state.cmykValue} type="text" id="cmykDisplay" style={{backgroundColor: this.state.inputBackground}} />
              <InputGroup.Button>
                <Button value="cmyk" onClick={this.handleCopyToClipboard}>Copy to Clipboard</Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>

        </div>
      </div>
    );
  }
}

export default ColorIO;



// WEBPACK FOOTER //
// ./src/components/ColorIO/ColorIO.js